import { PaymentMethod } from "./paymentsUtil";
import {
	attachSubmitEvent,
	BasisTheoryElement,
	BasisTheoryTokenType,
	initBasisTheoryField,
	preValidateFields,
	tokenizeCard
} from "../../components/payments/util";
import { FIELD_NAMES } from "../../util";
import { safeTry } from "../../services/services";

export class Card extends PaymentMethod {
	constructor(bt, configuration, customTheme, api) {
		const { cardInformation, ...billingAddressConfigs } = configuration.fields;
		super(billingAddressConfigs, customTheme, configuration?.onChangeValidation);
		this.configuration = configuration;
		this.api = api;
		this.bt = bt;
		this.theme = customTheme;
		this.validationErrors = {};
		attachSubmitEvent(configuration.submitButton, this.submitCallback);
	}

	init = async () => {
		const { cardInformation: cardConfig, ...billingAddressConfigs } = this.configuration.fields;
		this.initializeBillingInformation(billingAddressConfigs, this.theme, this.onChange);
		this.cardField = await initBasisTheoryField(
			this.bt,
			BasisTheoryElement.CARD,
			{
				config: cardConfig,
				theme: this.theme,
				fieldName: FIELD_NAMES.CARD_INFORMATION
			},
			this.onChangeValidation
		);
	};

	submitCallback = async () => {
		const submitButton = document.getElementById(this.configuration.submitButton.selector);
		submitButton.setAttribute("disabled", "true");

		/**
		 * @property {Boolean} success
		 * @property {Object} [paymentMethod]
		 * @property {CustomError[]} [errors]
		 */
		let apiResponse = { success: true, paymentMethod: null };

		const { cardInformation } = this.configuration.fields;

		const errors = await preValidateFields(this.billingAddressConfigs, this.billingInformation, this.theme, {
			cardInformation: { field: this.cardField, selector: cardInformation.selector }
		});

		if (errors.length) {
			apiResponse = {
				success: false,
				errors
			};
			this.configuration.submitButton.callback(apiResponse);
			submitButton.removeAttribute("disabled");
			return;
		}
		const [tokenizationResult, btError] = await safeTry(tokenizeCard(this.bt, this.cardField, this.billingInformation));
		if (btError) {
			submitButton.removeAttribute("disabled");
			apiResponse = this.handleBtError(btError, BasisTheoryTokenType.CARD);
			this.configuration.submitButton.callback(apiResponse);
			return;
		}

		const [odinResponse, odinError] = await safeTry(this.api.putPaymentMethod(tokenizationResult));
		apiResponse = this.handleOdinResponse(odinResponse, odinError);
		submitButton.removeAttribute("disabled");
		this.configuration.submitButton.callback(apiResponse);
	};
}
